import { Product, useJurisdictionStore } from '@/hooks/use-jurisdiction';

export const productNames = {
    [Product.Pickem]: 'Fantasy',
    [Product.Sweeps]: 'Social Sportsbook',
    [Product.Arcade]: 'Arcade',
    [Product.Casino]: 'Casino',
    [Product.Prediction]: 'Predictions',
    [Product.Rips]: 'Rips',
    [Product.None]: '',
};

export const useActiveProductName = () => {
    const product = useJurisdictionStore(state => state.product);
    return productNames[product];
};
